import React, { useEffect, useState } from 'react';
import { Icon, Pagination, Spin } from 'antd';
import { useLazyQuery } from '@apollo/client';

import { QUERY_REPORT_LANDLORD_COMMISSIONS } from '../../queries';

import Card from './card';

export default function CommissionReport({ t }) {
  const [commissionData, setCommissionData] = useState({});
  const [pageNumber, setPageNumber] = useState(1);

  const [queryReportCommission, { loading }] = useLazyQuery(QUERY_REPORT_LANDLORD_COMMISSIONS, {
    fetchPolicy: 'no-cache',
    variables: {
      input: {
        pageNumber,
      },
    },
    onCompleted: data => {
      if (data?.reportLandlordCommissions) {
        setCommissionData(data?.reportLandlordCommissions);
      }
    },
  });

  const handlePageNumberChange = page => {
    setPageNumber(page);
    queryReportCommission({ variables: { input: { pageNumber: page } } });
  };

  useEffect(() => {
    queryReportCommission();
  }, []);

  return (
    <div className="commission-report-wrapper">
      <p className="title">{t('cms.booking.commission_report.title')}</p>
      {loading && <Spin className="spin-loading" />}
      {!loading && (
        <>
          <div className="notice-wrapper">
            <Icon className="icon" type="info-circle" />
            <span className="created-date">
              {t('cms.booking.commission_report.created_date', { date: new Date().getFullYear() })}
            </span>
          </div>
          <div className="card-container">
            {commissionData?.landlords?.map(commission => (
              <Card commission={commission} t={t} />
            ))}
          </div>
          <Pagination
            className="pagination"
            hideOnSinglePage
            defaultCurrent={pageNumber}
            total={commissionData?.totalCount}
            onChange={handlePageNumberChange}
          />
        </>
      )}
    </div>
  );
}
